import { outcome } from "../../shared/protocol";
import type { DuelState } from "../lib/useDuel";

const fmt = (ms: number) => `${(ms / 1000).toFixed(1)}s`;

export function DuelResult({
  duel,
  onRematch,
  onBack,
}: {
  duel: DuelState;
  onRematch: () => void;
  onBack: () => void;
}) {
  const opp = duel.oppName || "Your rival";
  const result = outcome(duel.myScore, duel.oppScore, duel.myMs, duel.oppMs, duel.oppLeft);

  const line = {
    win: "You win!",
    loss: `${opp} wins`,
    draw: "Draw!",
    "win-speed": "You win on speed!",
    "loss-speed": `${opp} wins on speed`,
    "win-forfeit": `${opp} left — you win`,
  }[result];

  const time = `You ${fmt(duel.myMs)}${duel.oppMs ? ` · ${opp} ${fmt(duel.oppMs)}` : ""}`;

  return (
    <div className="result-card">
      <div className="direction">Duel over</div>
      <div className="result-line">{line}</div>
      <div className="result-score">
        {duel.myScore} – {duel.oppScore}
      </div>
      <div className="result-time">{time}</div>

      <div className="result-actions">
        {duel.side === "host" ? (
          <button type="button" className="btn btn-primary" onClick={onRematch}>
            Rematch
          </button>
        ) : (
          <div className="result-note">The host can start a rematch</div>
        )}
        <button type="button" className="btn btn-secondary" onClick={onBack}>
          Back to practice
        </button>
      </div>
    </div>
  );
}
